export default "__VITE_ASSET__CBzxs724__"